import rfiFreeText from '../globalComponents/RfiConstants/rfiFreeText.json'

/**
 * Get RFI const values by key
 * @param {*} key
 * @returns
 */
export const getRfiTagValues = (key) => {
  return rfiFreeText[key]
}
